import { gql } from '@apollo/client';

export const fetchCloudSitesForTransactionAccount = gql`
  query fetchCloudSitesForTransactionAccount($id: ID!, $searchOptions: ConnectionSearchOptions) {
    cloudSitesForTransactionAccount(id: $id, searchOptions: $searchOptions) {
      cloudSiteId
      cloudSiteHostname
    }
  }
`;

export const fetchCloudSitesForBillingpProfile = gql`
  query fetchCloudSitesForBillingpProfile($id: ID!) {
    cloudSitesForBillingProfile(id: $id) {
      cloudSiteId
      cloudSiteHostname
    }
  }
`;
